export const parseQuantity = (value) => {
  const numericValue = Number.parseInt(
    typeof value === 'string' ? value.trim() : value,
    10
  );
  if (!Number.isFinite(numericValue) || numericValue < 0) {
    return 0;
  }
  return numericValue;
};

export const parseCostPerItem = (value) => {
  if (value === undefined || value === null || value === '') {
    return 0;
  }

  const sanitized = typeof value === 'string' ? value.replace(/,/g, '').trim() : value;
  const numericValue = Number.parseFloat(sanitized);
  if (!Number.isFinite(numericValue) || numericValue < 0) {
    return 0;
  }
  return numericValue;
};
